
import React, { useEffect } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import Footer from "components/Footer/Footer";
import AdminNavbar from "components/Navbars/AdminNavbar";
import Sidebar from "components/Sidebar/Sidebar";
// import ChatGenie from "components/ChatGenie/ChatGenie";

import routes from "routes.js";

import sidebarImage from "assets/img/sidebar-3.jpg";
import ModalRoot from "components/UI/modalRoot";
import { useDispatch, useSelector } from "react-redux";
import { fetchOperatingUser } from "../redux/navigation/proprioceptor";
import { buildPermissionSet, hasRoutePermission } from "utils/pageAccess";

function Admin() {
  const navigator = useSelector((state) => state.navigation);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchOperatingUser());
  }, [dispatch]);

  let user = JSON.parse(localStorage.getItem('user'));
  if (!user) {
    return <Redirect to="/login" />
  }

  const [image, setImage] = React.useState(sidebarImage);
  const [color, setColor] = React.useState("black");
  const [hasImage, setHasImage] = React.useState(true);
  const location = useLocation();
  const mainPanel = React.useRef(null);
  const userPermissions = navigator.user.data?.user.user_permissions || [];
  const userPermissionSet = buildPermissionSet(userPermissions);
  
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      const hasPermission = hasRoutePermission(prop, userPermissionSet);

      if (prop.layout === "/admin" && hasPermission) {
        return (
          <Route
            path={prop.layout + prop.path}
            render={(props) => <prop.component {...props} />}
            key={key}
          />
        );
      }

      return null;
    });
  };


  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      var element = document.getElementById("bodyClick");
      element.parentNode.removeChild(element);
    }

  }, [location]);
  return (
    <>
      <div className="wrapper">
        <Sidebar color={color} image={hasImage ? image : ""} routes={routes} />
        <div className="main-panel" ref={mainPanel}>
          <AdminNavbar />
          <div className="content">
            <Switch>{getRoutes(routes)}</Switch>
              <ModalRoot />
          </div>
          <Footer />
        </div>
      </div>
      <FixedPlugin
        hasImage={hasImage}
        setHasImage={() => setHasImage(!hasImage)}
        color={color}
        setColor={(color) => setColor(color)}
        image={image}
        setImage={(image) => setImage(image)}
      />
      {/* <ChatGenie /> */}
    </>
  );
}

export default Admin;
